/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { CommentForm } from "~/components/Comment/CommentForm";
import { Val } from "~/components/InlineEdit/InlineComment";
import { Action } from "~/constants/actions";
import { SubmitComment } from "~/models/comments";

type CommentCreateProps = {
  onSubmit: (values: SubmitComment, type: string) => Promise<void>;
};

const StyledWrapper = styled.div`
  width: 60%;
`;

function CommentCreate({ onSubmit }: CommentCreateProps) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onCreate = async (values: Val) => {
    setIsLoading(true);

    await onSubmit(values as SubmitComment, Action.CREATE);
    setIsLoading(false);
  };

  return (
    <StyledWrapper>
      <CommentForm
        isLoading={isLoading}
        newComment
        onSubmit={onCreate}
        property="text"
      />
    </StyledWrapper>
  );
}

export { CommentCreate };
